import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import { ClientFacingWorkflowFragmentDoc } from '../app/hooks/useTrackClientFacingWorkflow.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GuestFeedbackRecommendationsListItemFragment = { __typename?: 'GuestFeedbackCorrectiveAction', id: string, title: string, issueDescription: string, priority: Types.ActionItemPriority, status: Types.GuestFeedbackCorrectiveActionStatus, actionType?: Types.GuestFeedbackRecommendationActionType | null, affectedLocations: Array<string>, correctiveActionGroupId: string, audience: Types.GuestFeedbackCorrectiveActionAudience, theme?: { __typename?: 'GuestFeedbackTheme', id: string, name: string } | null, sampleReviews: Array<{ __typename?: 'GuestFeedbackSampleReview', id: string, review: string }> };

export type GuestFeedbackRecommendationsQueryVariables = Types.Exact<{
  input: Types.GuestFeedbackRecommendationsInput;
}>;


export type GuestFeedbackRecommendationsQuery = { __typename?: 'Query', GuestFeedbackRecommendations: Array<{ __typename?: 'GuestFeedbackCorrectiveAction', id: string, title: string, issueDescription: string, priority: Types.ActionItemPriority, status: Types.GuestFeedbackCorrectiveActionStatus, actionType?: Types.GuestFeedbackRecommendationActionType | null, affectedLocations: Array<string>, acceptedAt?: string | null, completedAt?: string | null, measuringImpactStartedOn?: string | null, audience: Types.GuestFeedbackCorrectiveActionAudience, analysisRun?: { __typename?: 'GuestFeedbackAnalysisRun', id: string, startedAt: string, completedAt?: string | null } | null, theme?: { __typename?: 'GuestFeedbackTheme', id: string, name: string } | null, locationGroup?: { __typename?: 'LocationGroup', id: string, name: string, type: Types.LocationGroupType, brandDetails?: { __typename?: 'BrandDetails', id: string, logoUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, original: string } | null } | null } | null, locations: Array<{ __typename?: 'Location', id: number, name: string }>, sampleReviews: Array<{ __typename?: 'GuestFeedbackSampleReview', id: string, review: string }> }> };

export type GuestFeedbackAnalysisRunStatusQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GuestFeedbackAnalysisRunStatusQuery = { __typename?: 'Query', GuestFeedbackAnalysisRuns: Array<{ __typename?: 'GuestFeedbackAnalysisRun', id: string, startedAt: string, completedAt?: string | null, error?: string | null }> };

export type GuestFeedbackThemesQueryVariables = Types.Exact<{
  input: Types.GuestFeedbackThemesInput;
}>;


export type GuestFeedbackThemesQuery = { __typename?: 'Query', GuestFeedbackThemes: Array<{ __typename?: 'GuestFeedbackTheme', id: string, name: string, description: string, feedbackCount: number }> };

export type StartAiUpdateLibraryItemMutationVariables = Types.Exact<{
  input: Types.AiUpdateLibraryItemInput;
}>;


export type StartAiUpdateLibraryItemMutation = { __typename?: 'Mutation', startAIUpdateLibraryItem: { __typename?: 'ClientFacingWorkflowMutationResult', success: boolean, error?: { __typename?: 'Error', message?: string | null } | null, clientFacingWorkflow?: { __typename?: 'ClientFacingWorkflow', id: string, type: Types.ClientFacingWorkflowType, status: Types.ClientFacingWorkflowStatus, createdAt: string, result?: { __typename?: 'ClientFacingWorkflowResult', id: string, libraryItem?: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', en: string }, course?: { __typename?: 'Course', id: number, draftVersion: { __typename?: 'CourseVersion', id: number }, libraryItem: { __typename?: 'LibraryItem', id: string } } | null, skill?: { __typename?: 'Skill', id: number, draftVersion?: { __typename?: 'SkillVersion', id: string } | null, libraryItem: { __typename?: 'LibraryItem', id: string } } | null } | null } | null } | null } };

export type LinkLibraryItemToRecommendationMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
  input: Types.UpdateGuestFeedbackCorrectiveActionInput;
}>;


export type LinkLibraryItemToRecommendationMutation = { __typename?: 'Mutation', updateGuestFeedbackCorrectiveAction: { __typename?: 'GuestFeedbackCorrectiveActionMutationResult', success: boolean, error?: { __typename?: 'Error', message?: string | null } | null, correctiveAction?: { __typename?: 'GuestFeedbackCorrectiveAction', id: string, status: Types.GuestFeedbackCorrectiveActionStatus, libraryItem?: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', en: string } } | null } | null } };

export const GuestFeedbackRecommendationsListItemFragmentDoc = gql`
    fragment GuestFeedbackRecommendationsListItem on GuestFeedbackCorrectiveAction {
  id
  title
  issueDescription
  priority
  status
  actionType
  affectedLocations
  correctiveActionGroupId
  audience
  theme {
    id
    name
  }
  sampleReviews {
    id
    review
  }
}
    `;
export const GuestFeedbackRecommendationsDocument = gql`
    query GuestFeedbackRecommendations($input: GuestFeedbackRecommendationsInput!) {
  GuestFeedbackRecommendations(input: $input) {
    id
    title
    issueDescription
    priority
    status
    actionType
    affectedLocations
    acceptedAt
    completedAt
    measuringImpactStartedOn
    audience
    analysisRun {
      id
      startedAt
      completedAt
    }
    theme {
      id
      name
    }
    locationGroup {
      id
      name
      type
      brandDetails {
        id
        logoUrls {
          id
          thumb
          original
        }
      }
    }
    locations {
      id
      name
    }
    sampleReviews {
      id
      review
    }
  }
}
    `;

/**
 * __useGuestFeedbackRecommendationsQuery__
 *
 * To run a query within a React component, call `useGuestFeedbackRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestFeedbackRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestFeedbackRecommendationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGuestFeedbackRecommendationsQuery(baseOptions: Apollo.QueryHookOptions<GuestFeedbackRecommendationsQuery, GuestFeedbackRecommendationsQueryVariables> & ({ variables: GuestFeedbackRecommendationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GuestFeedbackRecommendationsQuery, GuestFeedbackRecommendationsQueryVariables>(GuestFeedbackRecommendationsDocument, options);
      }
export function useGuestFeedbackRecommendationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GuestFeedbackRecommendationsQuery, GuestFeedbackRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GuestFeedbackRecommendationsQuery, GuestFeedbackRecommendationsQueryVariables>(GuestFeedbackRecommendationsDocument, options);
        }
export type GuestFeedbackRecommendationsQueryHookResult = ReturnType<typeof useGuestFeedbackRecommendationsQuery>;
export type GuestFeedbackRecommendationsLazyQueryHookResult = ReturnType<typeof useGuestFeedbackRecommendationsLazyQuery>;
export type GuestFeedbackRecommendationsQueryResult = Apollo.QueryResult<GuestFeedbackRecommendationsQuery, GuestFeedbackRecommendationsQueryVariables>;
export const GuestFeedbackAnalysisRunStatusDocument = gql`
    query GuestFeedbackAnalysisRunStatus {
  GuestFeedbackAnalysisRuns {
    id
    startedAt
    completedAt
    error
  }
}
    `;

/**
 * __useGuestFeedbackAnalysisRunStatusQuery__
 *
 * To run a query within a React component, call `useGuestFeedbackAnalysisRunStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestFeedbackAnalysisRunStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestFeedbackAnalysisRunStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGuestFeedbackAnalysisRunStatusQuery(baseOptions?: Apollo.QueryHookOptions<GuestFeedbackAnalysisRunStatusQuery, GuestFeedbackAnalysisRunStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GuestFeedbackAnalysisRunStatusQuery, GuestFeedbackAnalysisRunStatusQueryVariables>(GuestFeedbackAnalysisRunStatusDocument, options);
      }
export function useGuestFeedbackAnalysisRunStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GuestFeedbackAnalysisRunStatusQuery, GuestFeedbackAnalysisRunStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GuestFeedbackAnalysisRunStatusQuery, GuestFeedbackAnalysisRunStatusQueryVariables>(GuestFeedbackAnalysisRunStatusDocument, options);
        }
export type GuestFeedbackAnalysisRunStatusQueryHookResult = ReturnType<typeof useGuestFeedbackAnalysisRunStatusQuery>;
export type GuestFeedbackAnalysisRunStatusLazyQueryHookResult = ReturnType<typeof useGuestFeedbackAnalysisRunStatusLazyQuery>;
export type GuestFeedbackAnalysisRunStatusQueryResult = Apollo.QueryResult<GuestFeedbackAnalysisRunStatusQuery, GuestFeedbackAnalysisRunStatusQueryVariables>;
export const GuestFeedbackThemesDocument = gql`
    query GuestFeedbackThemes($input: GuestFeedbackThemesInput!) {
  GuestFeedbackThemes(input: $input) {
    id
    name
    description
    feedbackCount
  }
}
    `;

/**
 * __useGuestFeedbackThemesQuery__
 *
 * To run a query within a React component, call `useGuestFeedbackThemesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestFeedbackThemesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestFeedbackThemesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGuestFeedbackThemesQuery(baseOptions: Apollo.QueryHookOptions<GuestFeedbackThemesQuery, GuestFeedbackThemesQueryVariables> & ({ variables: GuestFeedbackThemesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GuestFeedbackThemesQuery, GuestFeedbackThemesQueryVariables>(GuestFeedbackThemesDocument, options);
      }
export function useGuestFeedbackThemesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GuestFeedbackThemesQuery, GuestFeedbackThemesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GuestFeedbackThemesQuery, GuestFeedbackThemesQueryVariables>(GuestFeedbackThemesDocument, options);
        }
export type GuestFeedbackThemesQueryHookResult = ReturnType<typeof useGuestFeedbackThemesQuery>;
export type GuestFeedbackThemesLazyQueryHookResult = ReturnType<typeof useGuestFeedbackThemesLazyQuery>;
export type GuestFeedbackThemesQueryResult = Apollo.QueryResult<GuestFeedbackThemesQuery, GuestFeedbackThemesQueryVariables>;
export const StartAiUpdateLibraryItemDocument = gql`
    mutation StartAIUpdateLibraryItem($input: AIUpdateLibraryItemInput!) {
  startAIUpdateLibraryItem(input: $input) {
    success
    error {
      message
    }
    clientFacingWorkflow {
      ...ClientFacingWorkflow
    }
  }
}
    ${ClientFacingWorkflowFragmentDoc}`;
export type StartAiUpdateLibraryItemMutationFn = Apollo.MutationFunction<StartAiUpdateLibraryItemMutation, StartAiUpdateLibraryItemMutationVariables>;

/**
 * __useStartAiUpdateLibraryItemMutation__
 *
 * To run a mutation, you first call `useStartAiUpdateLibraryItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartAiUpdateLibraryItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startAiUpdateLibraryItemMutation, { data, loading, error }] = useStartAiUpdateLibraryItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartAiUpdateLibraryItemMutation(baseOptions?: Apollo.MutationHookOptions<StartAiUpdateLibraryItemMutation, StartAiUpdateLibraryItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartAiUpdateLibraryItemMutation, StartAiUpdateLibraryItemMutationVariables>(StartAiUpdateLibraryItemDocument, options);
      }
export type StartAiUpdateLibraryItemMutationHookResult = ReturnType<typeof useStartAiUpdateLibraryItemMutation>;
export type StartAiUpdateLibraryItemMutationResult = Apollo.MutationResult<StartAiUpdateLibraryItemMutation>;
export type StartAiUpdateLibraryItemMutationOptions = Apollo.BaseMutationOptions<StartAiUpdateLibraryItemMutation, StartAiUpdateLibraryItemMutationVariables>;
export const LinkLibraryItemToRecommendationDocument = gql`
    mutation LinkLibraryItemToRecommendation($id: UUID!, $input: UpdateGuestFeedbackCorrectiveActionInput!) {
  updateGuestFeedbackCorrectiveAction(id: $id, input: $input) {
    success
    error {
      message
    }
    correctiveAction {
      id
      status
      libraryItem {
        id
        name {
          en
        }
      }
    }
  }
}
    `;
export type LinkLibraryItemToRecommendationMutationFn = Apollo.MutationFunction<LinkLibraryItemToRecommendationMutation, LinkLibraryItemToRecommendationMutationVariables>;

/**
 * __useLinkLibraryItemToRecommendationMutation__
 *
 * To run a mutation, you first call `useLinkLibraryItemToRecommendationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkLibraryItemToRecommendationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkLibraryItemToRecommendationMutation, { data, loading, error }] = useLinkLibraryItemToRecommendationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkLibraryItemToRecommendationMutation(baseOptions?: Apollo.MutationHookOptions<LinkLibraryItemToRecommendationMutation, LinkLibraryItemToRecommendationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkLibraryItemToRecommendationMutation, LinkLibraryItemToRecommendationMutationVariables>(LinkLibraryItemToRecommendationDocument, options);
      }
export type LinkLibraryItemToRecommendationMutationHookResult = ReturnType<typeof useLinkLibraryItemToRecommendationMutation>;
export type LinkLibraryItemToRecommendationMutationResult = Apollo.MutationResult<LinkLibraryItemToRecommendationMutation>;
export type LinkLibraryItemToRecommendationMutationOptions = Apollo.BaseMutationOptions<LinkLibraryItemToRecommendationMutation, LinkLibraryItemToRecommendationMutationVariables>;